import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials lets axios send httpOnly auth cookies
export const api = axios.create({ baseURL: API, withCredentials: true });

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);

export const WHATSAPP_NUMBER = "919884041979";
export const whatsappLink = (msg = "Hi MileForge, I have a question") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const LOGO_URL = "/mileforge-logo.png";
